import type { ChatEmoticonItem } from '@module/apis/client-side/chat-emoticon/type';
import type { CountryCode } from '@module/apis/client-side/live/type';
import type { CentrifugeMessage } from '../messageTypes';
import type { FanLevel } from '../publicMessageTypes';

export type NormalChatMessageType = 'bj' | 'chatter' | 'manager' | 'guest' | 'support';

export type LangCode = 'ko' | 'ja' | 'zh' | 'en';

export interface NormalChatMessage {
  data: {
    type: NormalChatMessageType;
    message: string;
    emoticon: {
      block: ChatEmoticonItem;
      inline: unknown; // 추후 개발 예정
    } | null;
    id?: string;
    dt?: string;
    translate?: {
      ja?: string;
      sourceLanguage: 'ko';
      ko?: string;
    } | null;
    pf?: string;
    iat?: number;
    lang?: LangCode[];
    lcl?: CountryCode;
    ip?: string;
    sex?: 'M' | 'F' | 'U';
    idx?: number;
    nk?: string;
    nk_ja?: string;
    ndc?: number;
    vdc?: number;
    rk?: number;
    lev?: FanLevel;
    created_at?: number;
    siteChat?: string;
    filtered?: boolean;
  };
  seq?: unknown;
  gen?: unknown;
  offset: number | undefined;
  key?: string;
  /** 클라이언트 전용: 이 메시지가 batch mode(과부하) 중 도착했는지. useChatBatcher가 도착 시점에 스탬프. */
  receivedInBatchMode?: boolean;
}

export const isNormalChatMessage = (item: CentrifugeMessage): item is NormalChatMessage => {
  return (
    'data' in item &&
    (item.data.type === 'bj' ||
      item.data.type === 'chatter' ||
      item.data.type === 'manager' ||
      item.data.type === 'support')
  );
};

export type AdminChatMessageType = 'admin' | 'police';
export interface AdminChatMessage {
  data: {
    type: AdminChatMessageType;
    message: string;
    translate?: {
      ja?: string;
      sourceLanguage: 'ko';
      ko?: string;
    } | null;
    id?: string;
    pf?: string;
    iat?: number;
    lang?: LangCode[];
    ip?: string;
    sex?: 'M' | 'F' | 'U';
    idx?: number;
    nk?: string;
    created_at?: number;
    siteChat?: string;
  };
  offset: number | undefined;
}

export const isAdminChatMessage = (item: CentrifugeMessage): item is AdminChatMessage => {
  return 'data' in item && (item.data.type === 'admin' || item.data.type === 'police');
};

export const isSiteChatMessage = (item: CentrifugeMessage): item is NormalChatMessage => {
  return 'data' in item && Object.hasOwn(item.data, 'siteChat');
};
